import { horizontalDividerStyles } from "./horizontalDivider.css";

interface HorizontalDividerProps {
  dataContent?: string;
}

const HorizontalDivider = ({ dataContent }: HorizontalDividerProps) => (
  <hr className={horizontalDividerStyles} data-content={dataContent} />
);

export default HorizontalDivider;
